/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
 
// Add to cart
$(document).on('click','.cstm_ad_to_cart',function(e){
	e.preventDefault();
	var ID = $(this).attr("var_id");
	console.log(ID);
	$.ajax({
		type: 'POST',
		url: '/cart/add.js',
		data: {
			quantity: 1,
			id: $(this).attr("var_id")
		},
		dataType: 'json',
		success: function (data)
		{
			document.dispatchEvent(new CustomEvent("product:added", {detail:{product:data}}));
		}
	});
});

// PRODUCT PAGE TABS

function openCity(evt, cityName) {
  // Asegúrate de que `evt` no tenga un comportamiento predeterminado problemático
  evt.preventDefault();

  var i, tabcontent, tablinks;

  // Ocultar todos los contenidos de pestañas
  tabcontent = document.getElementsByClassName("tabcontent");
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].style.display = "none";
    tabcontent[i].setAttribute("aria-hidden", "true");
  }

  // Desactivar todas las pestañas
  tablinks = document.getElementsByClassName("tablinks");
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].classList.remove("active");
    tablinks[i].setAttribute("aria-selected", "false");
  }

  // Mostrar el contenido actual y marcar la pestaña activa
  document.getElementById(cityName).style.display = "block";
  document.getElementById(cityName).setAttribute("aria-hidden", "false");
  evt.currentTarget.classList.add("active");
  evt.currentTarget.setAttribute("aria-selected", "true");
}

// Activar la primera pestaña de manera controlada
document.addEventListener("DOMContentLoaded", function () {
  var defaultTab = document.getElementById("defaultOpen");
  if (defaultTab) {
    defaultTab.click();
  }
});



